module.exports = require("core-js/modules/es.number.to-fixed.js");